import * as React from 'react'

import {AppContext} from "../../Context/AppContext"
import {Headder} from "../Utils"

import "./css/style.scss"
import { Mesures } from './Mesures'
import { Site } from './Site'
import { PageSelector } from './PageSelector'
import { Events } from './Events'
import { TimeBoard } from '../Pages/TimeBoard'
import { CoefBoard } from '../Pages/CoefBoard'
import { UserApp } from './UserApp'
import { Create } from './Client/create'
import {Create as CreateSite} from './Site/create'
import { Loading } from '../Utils/Loading'
import { Client } from './Client'
import { ReactElement, useContext } from 'react'
import { Error } from 'react-error-popup'
import svgImg from './refresh-button.svg'
import { SmartVision } from './SmartVision'

export function Dashboard() {

    const {deconnexion} = React.useContext(AppContext)

    return (
        <div className="dashboard">
            <Headder deconnexion={deconnexion} />
            <Main/>
        </div>
    )
}

function Main(): ReactElement {
    const {client,setClient,clients,site,siteList, setSite,page,setPage,loading,role, errors, setErrors} = useContext(AppContext)
    return (
        <>
            <div className="menu">
                <div className="client">
                <label >Client :</label>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <select value={client} onChange={e=>{setClient(e.target.value)}} >
                    {
                        clients.map(cl=>
                            <option key={Math.random()} value={cl} >
                                {cl.split(':')[0]} : {cl.split(':')[1]} 
                            </option>
                        )
                    }
                    </select>
                    <img style={{marginLeft: '0.5em', cursor: 'pointer'}} src={svgImg} width={25} onClick={() => location.reload()} />
                </div>
                <label >Site</label>
                {siteList[0]?<select value={site} onChange={e=>{setSite(e.target.value)}} id="siteList" >
                {
                    siteList.map(cl=>
                        <option key={Math.random()} value={cl} >
                            {cl.split(":")[1]}
                        </option>
                    )
                }
                </select>:<div>le client selecrionné n'a pas de site</div>}
                </div>

                <PageSelector />
            </div>
            {loading?<Loading />:null}
            {page=="site"?<Site />:null}
            {page === "client"&& role === "SuperAdmin" && <Create /> }
            {page === "client-info" && <Client /> }
            {page === "createSite" && (role=="Admin"||role=="SuperAdmin")&& <CreateSite setPage={setPage} /> }
            {page=="horaires"?<TimeBoard />:null}
            {page=="mesures"?<Mesures />:null}
            {page=="events"?<Events />:null}
            {page=="flow"?<CoefBoard />:null}
            {role=="SuperAdmin" && page === "userapp" && <UserApp />}
            {role=="SuperAdmin" && page === "smartvision" && <SmartVision />}
            <Error listError={errors} setListError={setErrors} color={"#5E327C"} />
        </>

    )

        
}
